import './App.css';
import DashboardHeader from './dashboardheader.js'
import VerticalNavigation from './VerticalNavigation.js'
import AddClient from './forms/AddClient.js';

function ClientAdd() {
  return (
    <div className="App min-h-screen">
      <div className="dashboard-wrapper flex flex-col min-h-screen">
        <div className="dashboard-header flex w-full max-h-24 h-14">
          <DashboardHeader />
        </div>
        <div className="w-full flex flex-wrap min-h-screen">
          <div className="dashboard-left-sidebar flex-none w-48 relative">
            <VerticalNavigation />
          </div>
          <div className="dashboard-right-main border-2 flex-auto">
            <AddClient />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientAdd;
